import { render } from "./OverviewEditDiagramModal.vue?vue&type=template&id=a926a55e"
import script from "./OverviewEditDiagramModal.vue?vue&type=script&lang=js"
export * from "./OverviewEditDiagramModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__